import * as React from "react";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import {
  IconButton,
  Popover,
  Box,
  Tooltip,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
export default function CEQuickFilter({
  sx,
  className,
  iconOnly = false,
  ...props
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (iconOnly) {
    return (
      <>
        <Tooltip title="Search">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={(theme) => ({
              height: 36,
              width: 36,
              color: theme.palette.grey.main,
              borderColor: theme.palette.divider,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: "12px",
              "&:hover": {
                borderColor: theme.palette.primary.main,
                //backgroundColor: theme.palette.primary.buttonHoverSelected,
                color: theme.palette.primary.main,
              },
            })}
          >
            <SearchRoundedIcon />
          </IconButton>
        </Tooltip>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box sx={{ p: 2, minWidth: 260 }}>
            <GridToolbarQuickFilter
              {...props}
              debounceMs={props.debounceMs ?? 300}
              placeholder={props.placeholder ?? "Search…"}
              variant={props.variant ?? "outlined"}
              size={props.size ?? "small"}
              className={`CE-QuickFilter ${className || ""}`}
              sx={[
                (theme) => ({
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    height: 36,
                    borderRadius: "12px",
                    backgroundColor: theme.palette.background.default,
                    border: "1px solid transparent",
                    borderColor: theme.palette.divider,
                  },

                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.divider,
                  },

                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.primary.main,
                  },

                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: theme.palette.primary.main,
                      borderWidth: 2,
                    },

                  "& input": {
                    color: theme.palette.text.primary,
                  },

                  "& input::placeholder": {
                    color: theme.palette.text.secondary,
                    opacity: 1,
                  },

                  "& .MuiSvgIcon-root": {
                    color: theme.palette.text.secondary,
                  },
                }),
                ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
              ]}
            />
          </Box>
        </Popover>
      </>
    );
  }

  return (
    <GridToolbarQuickFilter
      {...props}
      debounceMs={props.debounceMs ?? 300}
      placeholder={props.placeholder ?? "Search…"}
      variant={props.variant ?? "outlined"}
      size={props.size ?? "small"}
      className={`CE-QuickFilter ${className || ""}`}
      sx={[
        (theme) => ({
          minWidth: 260,
          "& .MuiOutlinedInput-root": {
            height: 36,
            borderRadius: "12px",
            backgroundColor: theme.palette.background.default,
            border: "1px solid transparent",
            borderColor: theme.palette.divider,
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.divider,
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
          },

          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: theme.palette.primary.main,
              borderWidth: 2,
            },

          "& input": {
            color: theme.palette.text.primary,
          },

          "& input::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 1,
          },

          "& .MuiSvgIcon-root": {
            color: theme.palette.text.secondary,
          },
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    />
  );
}
